const CatalogTypes = {
  Customer: 2003,
  Item: 2002,
  ItemUOM: 2008,
  Warehouse: 2001,
  ShipTo: 2006,
  Carrier: 2005,
  AllowanceOrCharge: 2009,
  TaxGroup: 2011,
};

const CatalogTypesExt = {
  Customer: { Enum: CatalogTypes.Customer, Display: "Customer" },
  Item: { Enum: CatalogTypes.Item, Display: "Item" },
  ItemUOM: { Enum: CatalogTypes.ItemUOM, Display: "Item UOM" },
  Warehouse: { Enum: CatalogTypes.Warehouse, Display: "Warehouse" },
  ShipTo: { Enum: CatalogTypes.ShipTo, Display: "Ship To" },
  Carrier: { Enum: CatalogTypes.Carrier, Display: "Carrier" },
  AllowanceOrCharge: {
    Enum: CatalogTypes.AllowanceOrCharge,
    Display: "Discount or Charge",
  },
  TaxGroup: { Enum: CatalogTypes.TaxGroup, Display: "Tax Group" },
};

const ConnectionTypes = {
  Customer: 0,
  ERP: 1,
  Warehouse: 2,
};

const WorkflowLookupTypes = {
  ThreePLQualifiers: { value: 0, label: "3PL Qualifiers" },
  DefaultWarehouse: { value: 1, label: "Default Warehouse" },
  ImpliedDC: { value: 2, label: "Implied DC" },
  InventoryWarehouse: { value: 3, label: "Inventory Warehouse" },
};

export { CatalogTypes, CatalogTypesExt, ConnectionTypes, WorkflowLookupTypes };

export const WorkflowLookupMode = Object.freeze({
  Add: 0,
  Edit: 1,
});
